import SubscriptionSection from '../settings/SubscriptionSection';
import { useT } from '../i18n/i18n';

export default function SubscribePage() {
  const t = useT();
  return (
    <section aria-labelledby="sub-heading" style={{ maxWidth: 640, margin: '0 auto' }}>
      <h2 id="sub-heading" className="visually-hidden">{t('Subscription')}</h2>
      <SubscriptionSection />
    </section>
  );
}
